// Import mask images
import kn95PpeUs from '../../assets/kn95-ppe-us.webp';
import threePlyPpeUs from '../../assets/3-ply-ppe-us.webp';
import blackThreePlyPpeUs from '../../assets/black-3-ply-ppe-us.webp';
import inStockPpeUs from '../../assets/in-stock-ppe-us.webp';

export const disposableMasksProducts = [
    {
        image: kn95PpeUs,
        alt: 'KN95 Face Mask'
    },
    {
        image: threePlyPpeUs,
        alt: '3 Ply Disposable Face Mask'
    },
    {
        image: blackThreePlyPpeUs,
        alt: 'Black Disposable Face Mask'
    },
    {
        image: inStockPpeUs,
        alt: 'In Stock & Ready to Ship 24-48 Hours'
    }
]; 